import * as React from 'react'
import * as Common from '@tfo/common'
import { observer } from 'mobx-react'
import ReportsItemGroupArchived from './components/ReportsItemGroupArchived'

import './ReportsItem.scss'
import { ClientViewStore } from '../../../../../../stores/ClientViewStore'
import ReportsItemGroupStandard from './components/ReportsItemGroupStandard'
import ReportsItemGroupDelivered from './components/ReportsItemGroupDelivered'
import ReportsItemGroupWaitingApproval from './components/ReportsItemGroupWaitingApproval'
import { ReportState } from '../../ReportsEnums'

const State = Common.models.State

export interface ReportsItemProps {
	data: Common.models.IGroupOrder
	onClick: Function
	reportPackages: any[]
	store: ClientViewStore
}

const ReportsItem = (props: ReportsItemProps) => {
	const { data, onClick, reportPackages, store } = props
	const firstOrder = data.orders[0]

	if (store.reportsStore.activeStateFilter === ReportState.Archived) {
		return (
			<ReportsItemGroupArchived
				data={data}
				onClick={onClick}
				reportPackages={reportPackages}
				showCompanyName={props.store.reportsStore.hasSubsidaries}
			/>
		)
	}

	switch (firstOrder.state) {
		case State.Delivered:
			return (
				<ReportsItemGroupDelivered
					data={data}
					onClick={onClick}
					reportPackages={reportPackages}
					showCompanyName={props.store.reportsStore.hasSubsidaries}
				/>
			)
		case State.WaitingForConsent:
			return (
				<ReportsItemGroupWaitingApproval
					data={data}
					reportPackages={reportPackages}
					showCompanyName={props.store.reportsStore.hasSubsidaries}
					store={store}
				/>
			)
		default:
			return (
				<ReportsItemGroupStandard
					data={data}
					reportPackages={reportPackages}
					showCompanyName={props.store.reportsStore.hasSubsidaries}
					store={store}
				/>
			)
	}
}

export default observer(ReportsItem)
